//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as Actions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------


//  -- List chapter interactions ------


export const handleListOneGameVideo = () => async (dispatch) => {
    try {
        const video = await apis.get('one_game_video', `/list`);
        if (Array.isArray(video)) {
            await dispatch(Actions.listOneGameVideo(video));
        }
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing one game video',
                error,
                module: 'ONE_GAME_VIDEO',
                operation: 'LIST_ORGANIZATION_GROUP_VIDEO'
            })
        }
    }
};

export const handleCreateOneGameVideo = (data) => async (dispatch) => {
    try {
        const videos = await apis.post('one_game_video', `/create`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.createOneGameVideo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'creating one game video',
                error,
                module: 'ONE_GAME_VIDEO',
                operation: 'CREATE_ORGANIZATION_GROUP_VIDEO'
            })
        }
    }
};
export const handleUpdateOneGameVideo = (data) => async (dispatch) => {
    try {
        const videos = await apis.put('one_game_video', `/update`, {
            body: data
        });
        if (has(videos, "id")) {
            await dispatch(Actions.updateOneGameVideo(videos));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating one game video',
                error,
                module: 'ONE_GAME_VIDEO',
                operation: 'UPDATE_ORGANIZATION_GROUP_VIDEO'
            })
        }
        console.log(error, "error")
    }
};
export const handleDeleteOneGameVideo = (id) => async (dispatch) => {
    try {
        const videos = await apis.del('one_game_video', `/delete/${id}`);
        if (has(videos, "id")) {
            await dispatch(Actions.deleteOneGameVideo(id));
        }
        return videos;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting one game video',
                error,
                module: 'ONE_GAME_VIDEO',
                operation: 'DELETE_ORGANIZATION_GROUP_VIDEO'
            })
        }
    }
};